exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-placeholder[data-v-0746b238]{border:1px solid #d5d5d5;border-radius:50%;height:136px;width:136px;color:#fff;font-family:Open Sans,sans-serif;font-size:12px;font-weight:700;letter-spacing:0;line-height:17px;text-align:center;background-position:50%;background-size:contain;background-repeat:no-repeat;cursor:pointer;overflow:hidden;position:relative}.overlay-logo[data-v-0746b238]{background-color:#d5d5d5;opacity:0;width:100%;height:100%}.overlay-logo[data-v-0746b238]:hover{opacity:.2}", ""]);

// exports
